import configureStore from "./store/configureStore";
import { PubSubContext } from "./App";
import { Provider } from "react-redux";
import { useState, createContext } from "react";
import { THEME_LIGHT, THEME_DARK } from "./App.constant";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ProviderLanguage from "./components/ProviderLanguage";

export const store = configureStore(undefined);

export const themes: any = {
  [THEME_LIGHT]: {
    rootBackground: "--surface-neutral",
    rootTextColor: "--primary-text",
    userNameTagComponentBackground: "--light-blue-tag",
  },
  [THEME_DARK]: {
    rootBackground: "--surface-black",
    rootTextColor: "--surface-neutral",
  },
};

export const ThemeContext = createContext({
  theme: themes[THEME_LIGHT],
});

export const muiTheme = createTheme({
  typography: {
    fontFamily: "inherit",
  },
  zIndex: {
    modal: 1200,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiPopper: {
      defaultProps: {
        style: { zIndex: 1400 },
      },
    },
    MuiPopover: {
      defaultProps: {
        style: { zIndex: 1400 },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          zIndex: "1501 !important",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          "& .MuiTabs-indicator": {
            backgroundColor: "#6BBBE3",
            height: "0.25rem",
            borderRadius: "0.125rem",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          padding: "0",
          minWidth: "auto",
          marginRight: "1.5rem", // 6 * 4px (default spacing unit)
          textTransform: "none",
          color: "var(--primary-text)",
          fontWeight: 400,

          // Selected state styling
          "&.Mui-selected": {
            fontWeight: 600,
            color: "var(--primary-text)",
          },
        },
      },
    },
  },
});

function ChildProviderApp({ children }: any) {
  const [theme, setTheme] = useState(THEME_LIGHT);

  return (
    <ProviderLanguage
      isRTLCallback={(isRTL: any) => {
        document.documentElement.dir = isRTL ? "rtl" : "ltr";
      }}
    >
      <ThemeProvider theme={muiTheme}>
        <PubSubContext.Provider value={undefined as any}>
          <ThemeContext.Provider
            value={
              {
                theme: themes[theme],
                setTheme,
                themes,
                themeType: theme,
              } as any
            }
          >
            {children}
          </ThemeContext.Provider>
        </PubSubContext.Provider>
      </ThemeProvider>
    </ProviderLanguage>
  );
}

function ProviderApp({ children }: any) {
  return (
    <Provider store={store}>
      <ChildProviderApp>{children}</ChildProviderApp>
    </Provider>
  );
}

export default ProviderApp;
